import {
  Col,
  Form,
  Modal,
  Select,
  Tabs,
  Table,
  Button,
  Row,
  Divider,
  Card,
  InputNumber,
  Input,
} from 'antd';
import { useContext } from 'react';
import { PageContext } from '../../../lib/context';
import CustomerForm from './form';
import BarcodeScannerComponent from 'react-qr-barcode-scanner';
import AdditionalFeesForm from './addfeesform';
import Notes from './notes';
import CustomerReceit from '../customers/customer-receit';

const SubscriberView = () => {
  const {
    _onFinish,
    form,
    user,
    meters,
    subPayColumn,
    subBillColumn,
    billsTable,
    paymentsTable,
    subMeterColumn,
    meterReadingTable,
    setShowQR,
    showQR,
    _onFinishScan,
    _onFinishPay,
    showReceipt,
    handleCancel,
    payments_form,
    showCurrentReading,
    setShowCurrentReading,
    reading_form,
    _finishReading,
  } = useContext(PageContext);
  const { TabPane } = Tabs;

  let newMeters = [...meters];
  if (user?.meter) {
    newMeters = [...meters, { ...user.meter }];
  }

  const remaining_balance_title = () => {
    return (
      <div>
        <div className="text-sm font-semibold">
          REMAINING BALANCE: {user?.latest_payments?.balance?.toLocaleString()}
        </div>
      </div>
    );
  };

  return (
    <div className="px-2">
      <Card title={`${user?.first_name} ${user?.last_name}`}>
        <Tabs defaultActiveKey="1">
          <TabPane tab="Profile" key="1">
            <CustomerForm />
          </TabPane>
          <TabPane tab="Meter" key="2">
            <Col span={4}>
              <Button
                className="flex flex-col place-items-center"
                onClick={() => {
                  setShowQR(true);
                }}
              >
                Barcode Scanner
              </Button>
              <Modal
                title="Barcode Scanner"
                centered
                visible={showQR}
                closable
                footer={() => <div></div>}
                onCancel={() => setShowQR(false)}
              >
                <div className="self-center justify items center mb-5">
                  <BarcodeScannerComponent
                    width={500}
                    height={500}
                    onUpdate={(err, result: any) => _onFinishScan(result?.text)}
                  />
                </div>
              </Modal>
            </Col>
            <Divider></Divider>
            <Form form={form} onFinish={_onFinish}>
              <Row gutter={24}>
                <Col span={12}>
                  <Form.Item label="Meter" name="meter_id">
                    <Select
                      showSearch
                      filterOption={(input: any, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {newMeters.map((val: any, index: number) => {
                        return (
                          <Select.Option key={`${index}`} value={val.id}>
                            {val.serial_number}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    SAVE
                  </Button>
                </Form.Item>
              </Row>
            </Form>
            {/* <div>
              <Descriptions.Item label="meter_id">
                {`Meter ID: ${userMeterReading?.id}`}
              </Descriptions.Item>
            </div> */}
            <div className="flex flex-row mt-3">
              <div className="w-full mr-3">
                <Table
                  title={() => (
                    <div className="font-medium">METER READINGS</div>
                  )}
                  bordered
                  dataSource={meterReadingTable}
                  columns={subMeterColumn}
                />
              </div>
            </div>
          </TabPane>
          <TabPane tab="Bills" key="3">
            <div className="flex flex-row">
              <div className="w-full mr-3">
                <Table
                  dataSource={billsTable}
                  columns={subBillColumn}
                  title={remaining_balance_title}
                  bordered
                />
              </div>
            </div>
          </TabPane>
          <TabPane tab="Payments" key="4">
            <div className="flex flex-row">
              <div className="w-full mr-3">
                <Table dataSource={paymentsTable} columns={subPayColumn} />
              </div>
            </div>
          </TabPane>
          <TabPane tab="Additional Fees" key="5">
            <AdditionalFeesForm />
          </TabPane>
          <TabPane tab="Notes" key="6 ">
            <Notes />
          </TabPane>
        </Tabs>
        <Modal
          title="Customer Receit"
          visible={showReceipt}
          onCancel={handleCancel}
          onOk={handleCancel}
          width={1150}
          footer={
            <div style={{ textAlign: 'left' }}>
              <Form
                form={payments_form}
                onFinish={_onFinishPay}
                layout="vertical"
              >
                {/* {displayAmount && <> */}
                <Form.Item
                  name="amount"
                  rules={[{ required: true, message: 'Amount is required' }]}
                  label="Enter Amount"
                >
                  <div className="">
                    <InputNumber
                      placeholder="Enter Amount"
                      style={{ width: 350 }}
                    />
                  </div>
                </Form.Item>
                <Form.Item hidden={true} name="id">
                  <InputNumber />
                </Form.Item>
                <Form.Item hidden={true} name="billing_id">
                  <InputNumber />
                </Form.Item>
                <Form.Item hidden={true} name="subscriber_id">
                  <InputNumber />
                </Form.Item>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </div>
          }
        >
          <CustomerReceit />
        </Modal>
        <Modal
          visible={showCurrentReading}
          closable
          title="Update Current Reading"
          onCancel={() => setShowCurrentReading(false)}
          onOk={() => reading_form.submit()}
        >
          <Form form={reading_form} onFinish={_finishReading}>
            <Form.Item name="current_reading" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
            <Form.Item name="id" hidden>
              <Input />
            </Form.Item>
            <Form.Item name="current_reading_backup" hidden>
              <Input />
            </Form.Item>
          </Form>
        </Modal>
      </Card>
    </div>
  );
};

export default SubscriberView;
